import axiosInstance from '../api/axios';
import type { SupportActionLog, SupportShift, SupportShiftReport, SupportShiftViewer } from '@/types/supportShift';

export interface SupportShiftReportParams {
  min_hours?: number;
  max_hours?: number;
  start_date?: string;
  end_date?: string;
  support_id?: string;
}

export interface SupportActionsParams extends SupportShiftReportParams {
  shift_id?: string;
  search_id?: string;
  action_group?: 'appeal_closed' | 'appeal_fake' | 'appeal_other' | 'payout_closed';
}

export const supportShiftsService = {
  getSupports: async () => {
    const response = await axiosInstance.get<SupportShiftViewer[]>('/support-shifts/supports');
    return response.data;
  },

  getCurrent: async () => {
    const response = await axiosInstance.get<SupportShift | null>('/support-shifts/current');
    return response.data;
  },

  start: async () => {
    const response = await axiosInstance.post<SupportShift>('/support-shifts/start');
    return response.data;
  },

  stop: async (reason?: string) => {
    const response = await axiosInstance.post<SupportShift>('/support-shifts/stop', { reason });
    return response.data;
  },

  getReport: async (params: SupportShiftReportParams) => {
    const response = await axiosInstance.get<SupportShiftReport>('/support-shifts/report', {
      params,
    });
    return response.data;
  },
  updateReason: async (id: string, reason: string) =>
    (await axiosInstance.patch(`/support-shifts/${id}/reason`, { reason })).data,

  updateSalary: async (shiftId: string, salaryAmount: string | number) => {
    const response = await axiosInstance.patch<SupportShift>(
      `/support-shifts/${shiftId}/salary`,
      { salary_amount: salaryAmount },
    );
    return response.data;
  },

  updateValidity: async (shiftId: string, isValid: boolean) => {
    const response = await axiosInstance.patch<SupportShift>(
      `/support-shifts/${shiftId}/validity`,
      { is_valid: isValid },
    );
    return response.data;
  },

  getActions: async (params: SupportActionsParams) => {
    const response = await axiosInstance.get<SupportActionLog[]>('/support-shifts/actions', {
      params,
    });
    return response.data;
  },

  exportReport: async (params: SupportShiftReportParams & { format: 'csv' | 'xlsx' }) => {
    const response = await axiosInstance.get('/support-shifts/export', {
      params,
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `support_shifts.${params.format}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
